import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { tenantService } from '../services/api';
import CommercialOfferBox from '../components/CommercialOfferBox';
import VenuesManagementPanel from '../components/VenuesManagementPanel';

const TenantManagement = () => {
  const { tenantId } = useParams();
  const navigate = useNavigate();
  const [tenant, setTenant] = useState(null);
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const tenantEmail = tenant?.owner?.email || tenant?.email || 'N/A';
  const tenantPhone = tenant?.phone || 'N/A';

  const loadTenantData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const tenantData = await tenantService.getTenant(tenantId);
      setTenant(tenantData);
      setVenues(tenantData.venues || []);
    } catch (err) {
      console.error('Failed to load tenant data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [tenantId]);

  useEffect(() => {
    loadTenantData();
  }, [loadTenantData]);

  if (loading) return <div className="loading">Caricamento gestione tenant...</div>;
  if (!tenant) return <div className="error">Tenant non trovato</div>;

  return (
    <div>
      <div className="venue-header">
        <div className="venue-info">
          <h2>🏢 {tenant.company_name}</h2>
          <p>📧 {tenantEmail}</p>
          <p>📞 {tenantPhone}</p>
          <p><strong>🆔 ID:</strong> {tenant.id}</p>
          {tenant.signedContractOffer && (
            <CommercialOfferBox
              label={tenant.signedContractOffer.commercialOfferLabel}
              feePercent={tenant.signedContractOffer.commercialOfferFeePercent}
              feeFixedCents={tenant.signedContractOffer.commercialOfferFeeFixedCents}
              trialDays={tenant.signedContractOffer.commercialOfferTrialDays}
              setupFeeCents={tenant.signedContractOffer.commercialOfferSetupFeeCents}
              softwareSubscriptionFeeCents={tenant.signedContractOffer.commercialOfferSoftwareSubscriptionFeeCents}
              notes={tenant.signedContractOffer.commercialOfferNotes}
              style={{ marginTop: '10px' }}
            />
          )}
        </div>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate(-1)}
        >
          Indietro
        </button>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="card">
        <h3>📊 Statistiche del Tenant</h3>
        <div className="grid grid-4">
          <div className="stat-card">
            <h4>🏪 Locali</h4>
            <span className="stat-number">{venues.length}</span>
          </div>
          <div className="stat-card">
            <h4>👥 Team Totali</h4>
            <span className="stat-number">
              {venues.reduce((sum, v) => sum + (v._count?.teams || 0), 0)}
            </span>
          </div>
          <div className="stat-card">
            <h4>👷 Percettori Totali</h4>
            <span className="stat-number">
              {venues.reduce((sum, v) => sum + (v._count?.workers || 0), 0)}
            </span>
          </div>
          <div className="stat-card">
            <h4>📱 Totem Totali</h4>
            <span className="stat-number">
              {venues.reduce((sum, v) => sum + (v._count?.devices || 0), 0)}
            </span>
          </div>
        </div>
      </div>

      <VenuesManagementPanel
        lockedTenantId={tenantId}
        showIntro={false}
        showTenantColumn={true}
        showTenantFilter={false}
      />
    </div>
  );
};

export default TenantManagement;
